import { CONTEXT_ELEMENT_OP_AS_STR, ConditionGroupElement, StackContext } from '@pubstack/common/src/stackContext'
import { FunctionComponent, ReactNode, useState } from 'react'
import { Flyout } from '~/components/Flyout'
import { StackUsage } from '../../StackUsage'
import { StackUsageDetails } from '../../StackUsageDetails'

type PureAdmContextsDetailsFlyoutProps = {
  context: StackContext
}

const generateCondition = (condition: ConditionGroupElement): ReactNode => (
  <>
    {'key' in condition && (
      <div className={'flex flex-row gap-2.5'}>
        <span className={'font-medium'}>{condition.key}</span>
        <span className={'text-slate-grey'}>{CONTEXT_ELEMENT_OP_AS_STR[condition.op]}</span>
        <span className={'font-medium'}>{`[${condition.values.join(', ')}]`}</span>
      </div>
    )}
  </>
)

export const PureAdmContextsDetailsFlyout: FunctionComponent<PureAdmContextsDetailsFlyoutProps> = ({ context }) => {
  const [showUsage, setShowUsage] = useState(false)
  if (showUsage) return <StackUsageDetails name={context.name} stacksUse={context.stacksUse} onBack={() => setShowUsage(false)} />

  return (
    <Flyout.Content>
      <Flyout.Title>{context.name}</Flyout.Title>
      <Flyout.Body>
        <div className={'flex flex-col gap-5'}>
          <div className={'flex flex-col gap-2'}>
            <div className={'font-rubik text-base leading-6.5 font-medium'}>Identification</div>
            <div>
              <div className={'font-roboto text-sm leading-5.5 text-slate-grey'}>Name</div>
              <p>{context.name}</p>
            </div>
          </div>
          <div className={'flex flex-col gap-2'}>
            <div className={'font-rubik text-base leading-6.5 font-medium'}>Conditions</div>
            {context.conditions.elements.map(generateCondition).reduce((acc, condition, index) => [
              acc,
              <span key={index} className={'text-slate-grey'}>
                AND
              </span>,
              condition,
            ])}
          </div>
          <StackUsage stacksUse={context.stacksUse} onSeeAll={() => setShowUsage(true)} />
        </div>
      </Flyout.Body>
    </Flyout.Content>
  )
}
